import Vue from "vue";
import Vuex from "vuex";
import { AppStore } from "./modules/app";
import { AuthStore } from "./modules/auth";
import { ConfigStore } from "./modules/config";
import { PersonStore } from "./modules/person";
import { CatalogStore } from "./modules/catalog";
import { ContractsStore } from "./modules/contracts";
import { SettingsStore } from "./modules/settings";
import { TemplatesStore } from "./modules/templates";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: AuthStore,
    config: ConfigStore,
    app: AppStore,
    contracts: ContractsStore,
    settings: SettingsStore,
    person: PersonStore,
    catalog: CatalogStore,
    templates: TemplatesStore
  }
});
